import { Fragment } from 'react';
import { Trans } from '@lingui/react/macro';
import { Box, Label } from '@pocketlaw/tetris';
import { useCompanyFeatures } from 'app/domains/companies/features/CompanyFeatures';
import { AutoTag } from './AutoTag';
import { Location } from './Location';
import { Projects } from './Projects';
import { Container, Divider } from './styled';
export function UploadOptions(props) {
    const { folder, autoTag, projects, disabled, onSelectFolder, onChangeAutoTag, onChangeProjects } = props;
    const { isFeatureAvailable } = useCompanyFeatures();
    const isProjectsAvailable = isFeatureAvailable('PROJECTS');
    return (<Box flexDirection="column" gap="sm">
      <Label>
        <Trans comment="Upload documents dialog options label">Options</Trans>
      </Label>

      <Container>
        <Box flexDirection="column" gap="lg">
          <Location folder={folder} disabled={disabled} onSelectFolder={onSelectFolder}/>

          {isProjectsAvailable && (<Fragment>
              <Divider />
              <Projects projects={projects} disabled={disabled} onChangeProjects={onChangeProjects}/>
            </Fragment>)}

          <Divider />
          <AutoTag enabled={autoTag} disabled={disabled} onChange={onChangeAutoTag}/>
        </Box>
      </Container>
    </Box>);
}
